import { render, staticRenderFns } from "./convenios.vue?vue&type=template&id=4d1f914e"
import script from "./convenios.vue?vue&type=script&lang=js"
export * from "./convenios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports